import useIsCalmSleepApp from '@/hooks/useIsCalmSleepApp';

import ClassicUser from './ClassicUser';
import SleepUser from './SleepUser';

export default function DevTools() {
	const isCalmSleepApp = useIsCalmSleepApp();
	return isCalmSleepApp ? <SleepUser /> : <ClassicUser />;
}
